// extracted by mini-css-extract-plugin
module.exports = {"form":"form_2H-","search":"search_8Ax","btn-primary-service":"btn-primary-service_3CG"};